export function DocumentTitle(title) {
    if (title){
      document.title =title
    }
    else{
      document.title = "behina-bahramsari-portfolio";
    }
}


